export default __webpack_public_path__ + "static/media/club_executives.3f73fb62.jpg";